import React from 'react';
import PropTypes from 'prop-types';
import BloodTestHeader from './BloodTestHeader';
import DoctorRecommendations from './DoctorRecommendations';
import LifestyleGoals from './LifestyleGoals';
import Legend from './Legend';
import VitaminRow from './VitaminRow';

const TestReport = ({
  report,
  expanded = false,
  onToggle,
  allAirtableReports = [],
}) => {
  if (!report) return null;

  const { header, results, recommendations, lifestyleGoals, reportUrl } =
    report;
  const hasSupplements =
    Array.isArray(report.supplements) && report.supplements.length > 0;

  return (
    <div>
      <div className="mb-6">
        <BloodTestHeader
          header={header}
          orderId={report.orderId}
          reportUrl={reportUrl}
          airtablePreviewUrl={report?.airtablePreviewUrl}
          customerId={report?.customerId}
          recordId={report?.recordId}
          bloodTestId={report?.bloodTestId || report?.blood_test_id}
          prescriptionPrefill={report?.prescriptionPrefill}
          allAirtableReports={allAirtableReports}
          onToggle={onToggle}
          expanded={expanded}
        />
      </div>
      {expanded && (
        <div className="border-t border-[#EDEEF0] pt-[10px]">
          <div className="pt-6 pb-[23px]">
            <Legend />
          </div>
          <div className="border-t border-[#EDEEF0]" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 pt-6">
            <div className="lg:col-span-2">
              <div className="space-y-0">
                {(results || []).map((test, index) => (
                  <VitaminRow key={`${report.orderId}-${index}`} test={test} />
                ))}
              </div>
            </div>
            <div className="lg:col-span-1 lg:border-l lg:border-[#EDEEF0] lg:pl-8 pt-0">
              <div className="space-y-6">
                <DoctorRecommendations
                  items={recommendations || []}
                  resultDate={header?.resultDate}
                  doctor={report.doctor}
                />
                {hasSupplements && (
                  <LifestyleGoals
                    goals={lifestyleGoals || []}
                    context={{
                      orderId: report.orderId,
                      orderApprovalId:
                        report.orderApprovalId || report.order_id || '',
                      order_id: report.orderApprovalId || report.order_id || '',
                      recordId: report.recordId,
                      supPeriodId: report.supPeriodId,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

TestReport.propTypes = {
  report: PropTypes.shape({
    header: PropTypes.shape({
      type: PropTypes.string,
      testDate: PropTypes.string,
      resultDate: PropTypes.string,
    }).isRequired,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
    recommendations: PropTypes.arrayOf(PropTypes.object),
    lifestyleGoals: PropTypes.arrayOf(PropTypes.string),
    doctor: PropTypes.shape({
      name: PropTypes.string,
      bigNumber: PropTypes.string,
      photoUrl: PropTypes.string,
    }),
  }),
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  allAirtableReports: PropTypes.arrayOf(
    PropTypes.shape({
      customerId: PropTypes.string,
      recordId: PropTypes.string,
      airtablePreviewUrl: PropTypes.string,
    })
  ),
};

export default TestReport;
